/**
 * The Arcadia controlled form statuses for an Assess form.
 *
 * The values within this enum match the Arcadia ontology labels of type "FormStatus".
 */
export enum FormStatus {
  Approved = 'FormApproved',
  Cancelled = 'FormCancelled',
  InProgress = 'FormInProgress',
  InReview = 'FormInReview',
  Open = 'FormOpen',
  Rejected = 'FormRejected',
  Returned = 'FormReturned',
  Submitted = 'FormSubmitted',
  ReadyToSubmit = 'FormReadyToSubmit',
  ReadyToResubmit = 'FormReadyToResubmit',
  FormReopened = 'FormReopened',
}

export const formStatusPrefix = 'Form';

export const fromString = (key: string) =>
  FormStatus[key.replace(/\s/g, '').replace(formStatusPrefix, '') as keyof typeof FormStatus];
